<script>
	export let cls = ''
	export let bg = 'bg-white'
	export let padding = 'p-4'
	export let rounded = 'rounded-2xl'
</script>

<div class="{bg} {cls} {padding} {rounded} relative">
	<slot />
</div>
